import { FormatOption } from '@/modules/base/components/inputs/html-input/_helpers/getExtensions'
import { MenuSelectFontSizeProps } from 'mui-tiptap'

// Timing constants
export const BLUR_TIMEOUT_DELAY = 50
export const TOOLBAR_INTERACTION_DELAY = 100

// Format configurations
export const formatsFull: FormatOption[] = [
  'bold',
  'italic',
  'underline',
  'fontSize',
  'fontColor',
  'fontBackgroundColor',
  'undo',
  'redo',
  'link',
  'alignment',
  'bulletedList',
  'numberedList',
  'pageBreak',
  'placeholder',
  'mjmlButton',
]
// Toolbar selectors for click-outside detection
export const TOOLBAR_SELECTORS = [
  '.MuiTiptap-MenuBar',
  '.MuiPopover-root',
  '.MuiPopper-root',
  '[role="tooltip"]',
  '.MuiList-root',
  '.MuiMenuItem-root',
  '[data-mui-color-scheme]',
  '.MuiColorPicker-root',
  '.chrome-picker',
  '.sketch-picker',
]

export const FONT_SIZE_OPTIONS: MenuSelectFontSizeProps['options'] = [
  { value: '9px', 'label': '9' },
  { value: '10px', 'label': '10' },
  { value: '11px', 'label': '11' },
  { value: '12px', 'label': '12' },
  { value: '14px', 'label': '14' },
  { value: '16px', 'label': '16' },
  { value: '18px', 'label': '18' },
  { value: '20px', 'label': '20' },
  { value: '21px', 'label': '21' },
]
